import './style.scss'
import { WbsItemTypeVO } from '../../../domain/value-object/WbsItemTypeVO'
import ticketListIcon from '../../../assets/icons/global/ticket_list.svg'

/**
 * チケット管理表示用のアイコンを指定されたアイコンと組み合わせて表示する
 * @param type WbsItemTypeVO
 */
export const TicketListSubMenuItemsIcon = (type: WbsItemTypeVO) => {
  return (
    <>
      <div style={{ display: 'flex' }}>
        <img src={type.iconUrl} />
        <img src={ticketListIcon} style={{ height: '16px' }} />
      </div>
    </>
  )
}
